<script>import {
  cfgDiscordLink,
  cfgFacebookLink,
  cfgInstagramLink,
  cfgTelegramLink,
  cfgXLink,
  cfgYoutubeLink,
  stateUi
} from "@infinitro/config";
import {
  DiscordIcon,
  FacebookIcon,
  InstagramIcon,
  TelegramIcon,
  XIcon,
  YoutubeIcon
} from "@infinitro/icons";
const X_LINK = cfgXLink();
const DISCORD_LINK = cfgDiscordLink();
const TELEGRAM_LINK = cfgTelegramLink();
const FACEBOOK_LINK = cfgFacebookLink();
const INSTAGRAM_LINK = cfgInstagramLink();
const YOUTUBE_LINK = cfgYoutubeLink();
const socialMedia = [
  {
    name: "Discord",
    icon: DiscordIcon,
    link: DISCORD_LINK
  },
  {
    name: "X",
    icon: XIcon,
    link: X_LINK
  },
  {
    name: "Telegram",
    icon: TelegramIcon,
    link: TELEGRAM_LINK
  },
  {
    name: "Facebook",
    icon: FacebookIcon,
    link: FACEBOOK_LINK
  },
  {
    name: "Instagram",
    icon: InstagramIcon,
    link: INSTAGRAM_LINK
  },
  {
    name: "YouTube",
    icon: YoutubeIcon,
    link: YOUTUBE_LINK
  }
].filter((item) => item.link);
$: useAlternative2 = $stateUi.footer?.footerStyle === "alternative2";
</script>

<div class="sm-container">
	{#each socialMedia as { name, icon, link }}
		<a href={link} target="_blank" rel="noopener noreferrer">
			<div class="sm-item" class:sm-item-alt2={useAlternative2}>
				<span class:sm-item-icon={useAlternative2}>
					<svelte:component this={icon} />
				</span>
			</div>
		</a>
	{/each}
</div>

<style>
	.sm-container {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 1rem;
}
	.sm-item {
		display: flex;
		height: 2.5rem;
		width: 2.5rem;
		align-items: center;
		justify-content: center;
		border-radius: 0.375rem;
		border-width: 1px;
		border-color: var(--color-neutral-900);
		background-color: var(--component-footer-social);
}

	.sm-item-alt2 {
		border-radius: 6px;
		background:
			radial-gradient(
				101.56% 79.71% at 21.62% 50.54%,
				rgba(255, 255, 255, 0.1) 0%,
				rgba(255, 255, 255, 0) 100%
			),
			radial-gradient(
				35.59% 81.32% at 50% -16.3%,
				rgba(255, 255, 255, 0.2) 0%,
				rgba(255, 255, 255, 0) 100%
			);
		background-blend-mode: plus-lighter, plus-lighter;
	}

	.sm-item-icon {
		opacity: 0.4;
	}
</style>
